import { render, staticRenderFns } from "./recruitManage.vue?vue&type=template&id=b05fd0b0&scoped=true&"
import script from "./recruitManage.vue?vue&type=script&lang=js&"
export * from "./recruitManage.vue?vue&type=script&lang=js&"
import style0 from "./recruitManage.vue?vue&type=style&index=0&id=b05fd0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05fd0b0",
  null
  
)

export default component.exports